import rosieChat from 'assets/images/rosie-chat.png'
import { BlipChat } from 'blip-chat-widget'
import { useProperty } from 'store'
import isPreRendering from 'utils/isPreRendering'
import { fullDeviceAndOsInfo, origin_device } from 'utils/deviceDetector'
import { useEffect, useCallback } from 'react'

const customStyle = `
.fixed-options ul li div{
  text-align: left !important;  
  transition: 0.3s ease;      
}
.fixed-options ul li :hover{
  color: #126754;
  font-size: 16.5px;
}
.blip-card .text-left{
  text-align: center !important;
  font-weight: 700;
  font-size: 18px;
}
#blip-chat-header {
  background: #006754 !important;
  color: #ffffff !important;
}
.blip-card .bubble.right{
background-color: #126754 !important;
}
`

export const usePropertyBot = () => {
  const { getPropertyData } = useProperty()
  const property = getPropertyData()

  const setAutoOpenCount = useCallback(blipChat => {
    if (origin_device === 'desktop') {
      return setTimeout(() => {
        const { isOpen } = blipChat.widget

        if (isOpen) return null

        blipChat.sendMessage({
          type: 'text/plain',
          content: 'autoOpenChat',
          metadata: {
            '#blip.hiddenMessage': true,
          },
        })

        return blipChat.toogleChat()
      }, 15000)
    }
    return null
  }, [])

  useEffect(() => {
    let blipChat

    const bot = document.getElementById('blip-chat-container')
    if (bot) {
      bot.remove()
    }

    if (!isPreRendering()) {
      blipChat = new BlipChat()
        .withAppKey(process.env.REACT_APP_BLIP_KEY)
        .withButton({
          color: '#126754',
          icon: rosieChat,
        })
        .withCustomCommonUrl('https://chat.blip.ai')
        .withCustomStyle(customStyle)
        .withEventHandler(BlipChat.ENTER_EVENT, () => {
          if (window.screen.width <= 1024) {
            const elements = document.querySelectorAll(
              '[name=possibleFixedButton]'
            )
            if (elements) {
              elements.forEach(element => {
                element.setAttribute('style', 'display: none')
              })
            }
          }
        })
        .withEventHandler(BlipChat.LEAVE_EVENT, () => {
          const elements = document.querySelectorAll(
            '[name=possibleFixedButton]'
          )
          if (elements) {
            elements.forEach(element => {
              element.setAttribute('style', 'display: ""')
            })
          }
        })
        .withCustomMessageMetadata({
          property: JSON.stringify(property),
          origin_device,
          fullDeviceAndOsInfo: JSON.stringify(fullDeviceAndOsInfo),
        })
    }
    blipChat.build()

    let autoOpenChat
    if (blipChat) {
      autoOpenChat = setAutoOpenCount(blipChat)
    }

    return () => {
      if (autoOpenChat) clearTimeout(autoOpenChat)
    }
  }, [setAutoOpenCount, property])
}
